// extracted by mini-css-extract-plugin
module.exports = {"tabela":"PlanoNutrientes_tabela__3b0EF","cabecalho":"PlanoNutrientes_cabecalho__2TRHz"};